export default "__VITE_ASSET__CDRmEQUq__"